export default "__VITE_ASSET__Ce1phj07__"